import { render, staticRenderFns } from "./TestLogin.vue?vue&type=template&id=1e61c6ae"
import script from "./TestLogin.vue?vue&type=script&lang=js"
export * from "./TestLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports